type Work = {
  id: number | string;
  title: string;
  metadata?: { abstract?: string } | null;
  researchInterests?: Array<{ name: string }> | null;
};

export const isCoronavirusWork = (work: Work) => {
  return workIdWhitelist.includes(+work.id) || hasVirusTerms(work);
};

export const isCoronavirusTerm = (term: string) => coronavirusRegex.test(term);

const hasVirusTerms = (work: Work) => {
  const strings = [work.title];
  if (work.metadata && work.metadata.abstract)
    strings.push(work.metadata.abstract);
  if (work.researchInterests)
    strings.push(...work.researchInterests.map((ri) => ri.name));
  return strings.some((string) => coronavirusRegex.test(string));
};

const coronavirusRegex = /\b((corona)?virus|covid|sars)\b/i;

const workIdWhitelist = [
  // Hand-picked source works
  42323223, 42276020, 42343317, 18218371, 42343302,
  // Related works
  18218379, 7510352, 42132704, 10805149, 9029977, 16446986, 21285595, 28769918,
  42315119, 42294751, 17425367, 42283084, 25466831, 36910227, 19154190, 8337266,
  3342144, 22515388, 21917347, 14679440, 42318697, 20335090, 12450238, 20978237,
  20335073, 33914985, 16161491,
];
